import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f9f9ff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <span
        className="material-symbols-outlined"
        style={{ fontSize: 64, color: "#c1c6d3", marginBottom: "1.5rem", display: "block", lineHeight: 1 }}
      >
        search_off
      </span>
      <h1
        style={{
          fontFamily: "Public Sans, sans-serif",
          fontSize: "3rem",
          fontWeight: 800,
          color: "#00447f",
          marginBottom: "0.5rem",
        }}
      >
        404
      </h1>
      <p style={{ fontSize: "1.1rem", color: "#414751", marginBottom: "2rem" }}>
        Oups ! La page que vous recherchez n'existe pas.
      </p>
      <Link
        to="/"
        style={{
          backgroundColor: "#00447f",
          color: "#ffffff",
          textDecoration: "none",
          borderRadius: "0.5rem",
          padding: "0.875rem 2rem",
          fontWeight: 600,
          fontSize: "0.95rem",
          fontFamily: "Inter, sans-serif",
        }}
      >
        Retourner à l'accueil
      </Link>
    </div>
  );
}

export default NotFound;
